import React from 'react';

import UIConfig from '@/UIConfig.ts';

export const layoutContainerStyles: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  padding: 0
};

export const mainBoxStyles: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column'
};

export const bottomNavigationStyles: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  padding: 0,
  backgroundColor: UIConfig.Colors.BackgroundMedium,
  borderTop: '1px solid rgba(128, 128, 128, 0.3)',
  position: 'fixed',
  bottom: 0,
  width: '100%',
  height: '10%',
  zIndex: 3
};

export const listStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  width: '100%',
  padding: '10px 0'
};

export const listItemStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer'
};

export const listItemTextStyle: React.CSSProperties = {
  fontSize: '11px',
  marginTop: '3px',
  userSelect: 'none'
};

export const hasLikesBadgeStyle: React.CSSProperties = {
  position: 'absolute',
  top: 0.5,
  right: -2,
  backgroundColor: '#ff0000',
  borderRadius: '50%',
  width: 6,
  height: 6,
  border: '1.5px solid white'
};